import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';


class FlightReportWarningsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      flight_report_warnings: {},
    };
    //bind específico
    this.edit = this.edit.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_report_warnings) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        observations: newProps.flight_report.observations,
        flight_report_warnings: newProps.flight_report_warnings,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    if(navigator.onLine) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.props.flight_report_id,
        observations: this.state.observations,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/editar/observacoes', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
    
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div>
    <h3 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloObservacoes}</h3>
    <hr/>
    <form onSubmit={this.edit}>
      <div className="form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarObservacoes.Observacoes}:</label>
        <textarea style={{ height: 100 }} type="text" name="observations" className="form-control" placeholder="" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
      </div>
      <hr/>
      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarObservacoes.botaoEditarObservacoes}</button>
    </form>
    <hr />
    <h3 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloAlertasDoRelatorio}</h3>
    <hr/>
    <div className="table-responsive">
      <table className="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAlertasDoRelatorio.Mensagem}</th>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAlertasDoRelatorio.Data}</th>
          </tr>
        </thead>
        <tbody>
        {Object.keys(self.state.flight_report_warnings).map(function(k) {
          var srl = self.state.flight_report_warnings[k];
          return (
            <tr>
              <td className={"box-alert box-alert-" + srl.color} dangerouslySetInnerHTML={{__html: srl.message}}></td>
              <td className={"box-alert box-alert-" + srl.color}>{srl.created_at_str}</td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportWarningsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportWarningsTab.js